import type { ZendeskAPI } from './zendesk';

export function getZendeskChat(): ZendeskAPI | undefined {
	return typeof window.zE === 'function' ? window.zE : undefined;
}
